<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="lockForm.recKey"
                          :label="labels.recKey"
                          :error-messages="errors.collect('recKey')"
                          data-vv-name="recKey"
                          :data-vv-as="labels.recKey"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="lockForm.recUsrId"
                          :label="labels.recUsrId"
                          :error-messages="errors.collect('recUsrId')"
                          data-vv-name="recUsrId"
                          :data-vv-as="labels.recUsrId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-autocomplete
                          :items="recTypes"
                          v-model="lockForm.recType"
                          :label="labels.recType"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('recType')"
                          data-vv-name="recType"
                          :data-vv-as="labels.recType"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-autocomplete
                          :items="recStats"
                          v-model="lockForm.recStat"
                          :label="labels.recStat"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('recStat')"
                          data-vv-name="recStat"
                          :data-vv-as="labels.recStat"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="lockForm.createdDate"
                          :label="labels.createdDate"
                          :data-vv-as="labels.createdDate"
                          data-vv-name="createdDate"
                          :error-messages="errors.collect('createdDate')"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-card-title>
        <v-flex class="text-right">
          <v-btn color="primary" @click.native="doUnLock">
            <span>{{ lblUnLock }}</span>
            <v-icon right dark>mdi-lock-open</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <!-- <v-data-table v-bind:headers="recLckColumns" v-bind:items="items" :server-items-length="totalItems" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" item-key="recKey" :loading="loading" :no-data-text="noDataText">
                 <template v-slot:item="row">
                  <td style="width:50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.recKey)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.recKey }}</td>
                  <td class="text-xs-left">{{ row.item.recUsrId }}</td>
                  <td class="text-xs-left">{{ row.item.recType }}</td>
                  <td class="text-xs-left">{{ row.item.recStat }}</td>
                  <td class="text-xs-left">{{ row.item.createdDate }}</td>
                </template>
              </v-data-table> -->
        <v-data-table
          :headers="recLckColumns"
          :items="items"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :loading="loading"
          :server-items-length="totalItems"
          :custom-filter="customSearch"
          :no-data-text="noDataText"
          show-select
          item-key="recKey"
          v-bind:options.sync="pagination"
          v-model="checkedItems"
        >
        </v-data-table>
      </v-flex>
    </v-card>
    <confirm v-model="promptUnLock" @ok="doConfirmUnLock">
      <p>{{ lblPromptUnLock }}</p>
      <div class="queryValue">Record Key: {{ selected }}<br /></div>
    </confirm>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import clone from 'clone'
import { formatDisplayDateTime2, formatDisplayDateTime, removeTime } from '@/utils/date'

export default {
  data() {
    return {
      init: 0,
      menu: {},
      recTypes: [
        { label: 'Underwriting', value: 'POL' },
        { label: 'Claims', value: 'CLM' },
        { label: 'Accounts', value: 'ACT' },
        { label: 'Reinsurance', value: 'RI' }
      ],
      recStats: [
        { label: 'Closed', value: 'C' },
        { label: 'Locked', value: 'L' },
        { label: 'Open', value: 'O' }
      ],
      labels: {
        recKey: 'Record Key',
        recUsrId: 'User Email',
        recType: 'Record Type',
        recStat: 'Status',
        createdDate: 'Created Date'
      },
      lockForm: {
        recKey: undefined,
        recUsrId: undefined,
        recType: undefined,
        recStat: undefined,
        createdDate: undefined
      },
      branches: [],
      processing: false,
      totalItems: 0,
      items: [],
      selectedPage: 0,
      recLckColumns: [
        { text: 'Record Key', value: 'recKey' },
        { text: 'User ID', value: 'recUsrId' },
        { text: 'Module', value: 'recType' },
        { text: 'Status', value: 'recStat' },
        { text: 'Date Created', value: 'createdDate' }
      ],
      lblUnLock: 'UnLock',
      checkedItems: [],
      lblPromptUnLock: 'Are you sure you want to unLock record?',
      promptUnLock: false,
      selected: [],
      pagination: {}
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      const apiURI = this.$store.state.app.menu.commonUtility
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
          }
        } catch (err) {}
        this.performSearch()
      }
    },
    doUnLock() {
      let temp = []
      if (this.checkedItems.length > 0) {
        for (var a = 0; a < this.checkedItems.length; a++) {
          temp.push(this.checkedItems[a]['recKey'])
        }
        this.selected = temp
        this.promptUnLock = true
      } else {
        this.$toast.error('Please select at least one record to unlock.')
      }
    },
    async doConfirmUnLock() {
      const apiUrl = this.menu.unlockRecord
      const itemList = []
      try {
        for (var a = 0; a < this.checkedItems.length; a++) {
          const requestParams = {
            recKey: this.checkedItems[a]['recKey']
          }
          itemList.push(requestParams)
        }
        const expand = {
          checkedItems: itemList
        }
        if (apiUrl) {
          this.$http
            .post(apiUrl, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.doClearFilters()
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.notify(data)
              }
            })
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    async performSearch() {
      const apiUrl = this.menu.performSearch
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage === -1 ? this.totalItems : itemsPerPage
          }
          let messageFilters = clone(this.lockForm)
          if (messageFilters.createdDate !== '') {
            messageFilters.createdDate = formatDisplayDateTime2(removeTime(messageFilters.createdDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, paramMap), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((result) => {
              let recTypesDesc
              let recStatDesc
              this.recTypes.forEach((data) => {
                if (data.value === result.recType) {
                  recTypesDesc = data.label
                }
              })
              this.recStats.forEach((data) => {
                if (data.value === result.recStat) {
                  recStatDesc = data.label
                }
              })
              const resultList = {
                recKey: result.recKey,
                recUsrId: result.usrEmail,
                recType: recTypesDesc,
                recStat: recStatDesc,
                createdDate: this.formatDisplayDateTime(result.createdDate)
              }
              this.items.push(resultList)
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    collectItems(event, item) {
      if (event) {
        this.checkedItems.push(item)
        this.checkedItems.sort()
      } else {
        this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
        this.checkedItems.sort()
      }
    },
    doClearFilters() {
      var thisPage = this
      Object.keys(this.lockForm).forEach(function (key, index) {
        thisPage.lockForm[key] = ''
      })
      this.performSearch()
      this.checkedItems = []
    },
    doFilters() {
      this.performSearch()
      this.checkedItems = []
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    }
  },
  computed: {},
  watch: {
    'pagination': function (value) {
      this.performSearch(false)
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
